module.exports = __webpack_public_path__ + "static/images/visa-1e690fca.png";